import { App } from 'vue'
import { autofocus } from '@ezio/ui/directives'

export const initDirectives = (app: App) => {
    //v-auto-focus
    app.directive('autoFocus', autofocus)
}
